import { render, staticRenderFns } from "./TemplatesPage.vue?vue&type=template&id=ec2655ac&scoped=true&"
import script from "./TemplatesPage.vue?vue&type=script&lang=ts&"
export * from "./TemplatesPage.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesPage.vue?vue&type=style&index=0&id=ec2655ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2655ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VImg,VRow})
